import { Input, Flex as WebFlex } from '@aloft/toolkit-sui';

import { useState } from 'react';

import { PDFOnly } from '../../../summary/components/PDFOnly.tsx';
import { Typography } from '../../../summary/components/Typography.tsx';
import { WebOnly } from '../../../summary/components/WebOnly.tsx';
import { SummarySection } from '../SummarySection.tsx';
import { SummaryTableHorizontal } from '../SummaryTableHorizontal.js';
import { TitleAndExportToggleLockup } from '../TitleAndExportToggleLockup.tsx';
import { Tkv2PairedCostSummaryInterfaceV2 } from '../types.ts';
import { adjustment } from '../utils/formatters/adjustment.ts';
import { calculations } from '../utils/formatters/calculations.ts';
import { PairedCostSettingsBreakdown } from './PairedCostSettingsBreakdown.tsx';
import { hasAdjustments } from './hasAdjustments.ts';

export const AdjustmentBreakdownCondition = (props: Tkv2PairedCostSummaryInterfaceV2) => {
  const commentaryProps = props.exportableCommentaries.condition;
  const [commentary, setCommentary] = useState(commentaryProps.commentary);

  if (!hasAdjustments(props.results, 'condition')) {
    return null;
  }

  return (
    <SummarySection>
      <TitleAndExportToggleLockup
        {...props}
        title="Condition Adjustment"
        id="isConditionCommentaryInExport"
        commentary={commentaryProps}
      />
      <Typography variant="body1">
        The condition adjustment is calculated by subtracting the subject’s depreciation from the
        comparable’s depreciation.
      </Typography>
      <PDFOnly>
        <Typography variant="body1">{commentaryProps.commentary}</Typography>
      </PDFOnly>
      <SummaryTableHorizontal
        {...props}
        compSequence={props.compSequence}
        summary={props}
        columns={[
          {
            header: 'Age / Condition',
            type: 'feature',
            path: 'ageCondition',
            adjustmentType: 'condition',
          },
          {
            header: 'Adjustment Calculation',
            type: 'adjustment',
            path: 'calculations',
            valueFormatter: calculations,
            adjustmentType: 'condition',
          },
          {
            header: 'Adjustment',
            type: 'adjustment',
            path: 'adjustment',
            valueFormatter: adjustment,
            textAlign: 'right',
            adjustmentType: 'condition',
            includeTooltip: true,
          },
        ]}
      />
      <PairedCostSettingsBreakdown {...props} type="condition" />
      <WebOnly>
        <WebFlex marginTop="1rem" width="40rem">
          <Input
            type="multiline"
            onChange={setCommentary}
            value={commentary}
            onClear={() => setCommentary('')}
            onBlur={() => commentaryProps.updateCommentary(commentary)}
            resize="both"
            label="Commentary"
            size="sm"
          />
        </WebFlex>
      </WebOnly>
    </SummarySection>
  );
};
